<div class="dashboard-landing d-flex flex-column justify-content-center align-items-center">
  <div class="text-center">
    <!-- <img src="assets/gail-logo.png" alt="GAIL Logo" style="width:80px; margin-bottom: 1.5rem;" /> -->
    <h1 class="mb-3" style="font-weight:700; color:#006937;">Welcome to CNG Mitra Application</h1>
    <h4 class="mb-4" style="color:#555;">GAIL Gas Limited</h4>
    <p class="mb-4" style="font-size:1.1rem; color:#333;">
      </p>
  </div>
</div>